// i18n 
(function() {
	const sel = document.querySelectorAll('.i18n-selector');
	if( sel.length === 0 ) {
		return;
	}
	
	const className = 'open';
	
	sel.forEach(s => {
		const button = s.querySelector('.i18n-selector-toggle');
		
		button.addEventListener('click', event => {
			s.classList.toggle(className);
		});
	});
}());